<template>
    <div class="d-inline-flex align-center rounded c-quantity-changer" :class="{dense}">
        <v-btn :loading="loading" class="px-0 plus-minus v-btn--variant-elevated" rounded="0" elevation="0" @click="toAdd = plusMinus(toAdd, false)"
               :disabled="[0, 1].includes(toAdd) || disabled" :class="{
                    'rounded-ts rounded-bs border-s border-t border-b ': !borderless
               }">
            <v-icon :icon="mdiMinus"/>
        </v-btn>
        <span v-if="!hideValue" class="px-5 " :class="{
            ' c-quantity-changer__value border-t border-b': !borderless,
            'w-100 text-center': borderless
        }">{{toAdd}}</span>
        <v-btn :loading="loading" class="px-0 plus-minus v-btn--variant-elevated" rounded="0" elevation="0" @click="toAdd = plusMinus(toAdd, true, {limit:stock})"
               :disabled="toAdd === stock || stock <= 0 || disabled" :class="{
                'rounded-te rounded-be border-e border-t border-b ': !borderless
               }">
            <v-icon :icon="mdiPlus"/>
        </v-btn>
    </div>
</template>

<script setup>
import {ref, watch} from "vue";
import {plusMinus} from "../utils/cart";
import {mdiMinus, mdiPlus} from "@mdi/js";

const props = defineProps({
    stock: Number,
    modelValue: Number,
    dense: Boolean,
    loading: Boolean,
    disabled: Boolean,
    hideValue: {
        type: Boolean,
        default: false
    },
    borderless: {
        type: Boolean,
        default: false
    }
});
const toAdd = ref(props.modelValue && props.modelValue > 0 ? props.modelValue || (props.stock > 0 ? 1 : 0) : props.stock > 0 ? 1 : 0);
watch(toAdd, (value) => {
    emit('update:modelValue', value);
})
watch(() => props.modelValue, (value) => {
    toAdd.value = value;
})
watch(() => props.stock, (val) => {
    if(val === 0){
        toAdd.value = 0;
        return;
    }
    if(val < toAdd.value){
        toAdd.value = val;
        return;
    }
    if(val && !toAdd.value){
        toAdd.value = 1;
    }
})
const emit = defineEmits(['update:modelValue']);
</script>

<style scoped lang="scss">
.c-quantity-changer{
    &:not(.dense){
        --v-input-control-height: 48px;
        .plus-minus{
            height: var(--v-input-control-height);
        }
    }
}
.c-quantity-changer__value{
    user-select: none;
    display: inline-flex;
    align-self: stretch;
    align-items: center;
}
</style>
